import { Close, Save } from "@mui/icons-material";
import { IconButton, Stack, TextField} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import Picture from "../../Inputs/Picture";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext";
import { txt } from "../../../services/translation";

export default function QuestionForm({question, onSubmit, onCancel}){

    const {setToast} = useContext(ToastContext)

    const [data, setData] = useState(null)

    useEffect(() => {

        setData({...question})

    }, [question])

    const handleSubmit = e => {
        e.preventDefault()
        return onSubmit(data)
    }

    const sx = {
        margin: 'auto', 
        p: 1,
        maxWidth: 500
    }

    const handlePictureChange = file => {

        if(file){

            API.upload('/pictures', file)
                .then(r => setData({...data, picture: r.data}))
                .catch(e => setToast({severity: 'error', message: txt('imageTooHeavyOrWrongFormat')}))

        }else{

            setData({...data, picture: null})
        }
    }
    
    return data && <form onSubmit={handleSubmit}>

        <Stack spacing={3} sx={sx}>

                <Stack direction='row' justifyContent='flex-end'>
                    <IconButton size='small' color='primary' type='submit'>
                        <Save/>
                    </IconButton>

                    <IconButton size='small' color='error' onClick={onCancel}>
                        <Close/>
                    </IconButton>
                </Stack>

                <Picture
                    id={'picture' + data.id}
                    label={txt('pictureLabel')}
                    value={data.picture}
                    onChange={handlePictureChange}
                />

                <TextField
                    label={txt('correctionLabel')}
                    value={data.explanation || ''}
                    onChange={e => setData({...data, explanation: e.target.value.substring(0, 3000)})}
                    inputProps={{maxLength: 3000}}
                    multiline
                    minRows={3}
                />


        </Stack>

    </form>
}